// 

$(document).ready(function() {
  $('.product-badge-enable-flickty').flickity('destroy'); 
    if($(".cart-flickty-slider-enabled").length > 0){
      setTimeout(function() {
        var cart_flkty = new Flickity('.cart-flickty-slider-enabled', {
          // groupCells: 3,
          wrapAround: true,
          cellAlign: 'left',
          pageDots: false,
          initialIndex: 1,
          accessibility: true,
          autoPlay: false
        });
      },100);
    }else{
     setTimeout(function() { 
       if ($('#freesample-mini-cart').hasClass('flickity-enabled') || $('#freesample-mini-cart').hasClass('grid-pro-jtpl')) {
              $("#freesample-mini-cart").flickity('destroy');
              clearInterval(interval);
          }
           },100);
    }

  document.addEventListener('cart:updated', function(event) {
      // Your custom function
      ClearCartDrawerSample(event);
  });
  
  var isFlickity = false;

  function enableSlider() {
    console.log("enable Sliderrr")
      var interval = setInterval(function() {
          if ($('#freesample-mini-cart').hasClass('flickity-enabled') || $('#freesample-mini-cart').hasClass('grid-pro-jtpl') ) {
              $("#freesample-mini-cart").flickity('destroy');
              clearInterval(interval);
          } else {
              var flkty = new Flickity("#freesample-mini-cart.cart-flickty-slider-enabled", {
                  wrapAround: true,
                  pageDots: false,
                  initialIndex: 1,
                  accessibility: true,
                  autoPlay: false,
                groupcells:2
              });
              clearInterval(interval);
              var divCount = $(".flickity-slider .total-modalninfo").length;
                if (divCount <= 2) {
                  $(".free-sample-products").addClass("arrow-disabled");
                }else {
                  $(".free-sample-products").removeClass("arrow-disabled");
                }
          }
      });
  }
});

  // if($('#freesample-mini-cart').hasClass('.flickity-enabled')){
  //   //$('#freesample-mini-cart .spend-get-gift').show();
  //     $("#freesample-mini-cart").flickity('destroy');
  //   clearInterval(interval);
  // }else{
  //   isFlickity = true;
  //  // $('#freesample-mini-cart .spend-get-gift').hide();
  //   $('#freesample-mini-cart').flickity({
  //     wrapAround: true,
  //     pageDots: false,
  //     initialIndex: 1,
  //     accessibility: true,
  //     autoPlay: false
  //   });
  //   clearInterval(interval);
  // }

//}
function slideFreeGift(){
      var timeinterval = setInterval(function(){ 
              var divCount = $(".flickity-slider .total-modalninfo").length;
              if (divCount <= 2) {
                $(".free-sample-products").addClass("arrow-disabled");
              }else {
                $(".free-sample-products").removeClass("arrow-disabled");
              }
               if($('.gift_item').length==0){
                 $('.spend-get-gift').hide();
                 clearInterval(timeinterval);
               }else{
                 $('.spend-get-gift').show();
                  if($('.free-sample-main-section').length>0 && $(window).width() > 750){ 
                   $('.free-sample-products').attr("style","display:none");
                        $('.main-headingcontent-jtpl').addClass('close');
                 }
                  if($(window).width() < 750){
                      if($('.free-sample-main-section').length>0){ 
                         $('.free-sample-products').attr("style","display:none");
                        $('.main-headingcontent-jtpl').addClass('close');
                     }
                 }
                   clearInterval(timeinterval);
               }  
             },500);
}

function updateCart(){
    setTimeout(function (){
    var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    if(url.indexOf("/cart") > -1){
      window.location.href = "/cart";
      return false;
       $.ajax({
          url: '/cart?section_id=main-cart-footer',
          async: false,
          type: 'GET',
          dataType: 'html',
          success:function(carthtml) {
            console.log(carthtml)
            $('#main-cart-footer').html($(carthtml).find('#main-cart-footer').html());
            validateMaxfreeSample();
          }
        });
      $.ajax({
          url: '/cart?section_id=main-cart-items',
          async: false,
          type: 'GET',
          dataType: 'html',
          success:function(carthtml) {
            $('#main-cart-items').html($(carthtml).find('#main-cart-items').html());
            validateMaxfreeSample();
          }
        });
      $.ajax({
          url: '/cart?section_id=mini-cart__shippingbar',
          async: false,
          type: 'GET',
          dataType: 'html',
          success:function(carthtml) {
            $('#mini-cart__shippingbar').html($(carthtml).find('#mini-cart__shippingbar').html());
            validateMaxfreeSample();
          }
        });
     slideFreeGift();

     }else{
      $("div.loader-cart-drwer-jtpl").addClass("loading");
      $("div.loader-cart-drwer-jtpl.loading").show();
       $.ajax({
          url: '/pages/contact-us?section_id=mini-cart',
          async: false,
          type: 'GET',
          dataType: 'html',
          success:function(carthtml) {
            $("form div.mini-cart__inner").hide();
            // console.log(carthtml);
            $('#main-cart-items').html($(carthtml).find('#main-cart-items').html());
            $('#mini-cart__shippingbar').html($(carthtml).find('#mini-cart__shippingbar').html());
            $('.mini-cart__footer').html($(carthtml).find('.mini-cart__footer').html());
            validateMaxfreeSample();
            $("form div.mini-cart__inner").show();

            if ($("form.mini-cart .mini-cart__navigation li.mini-cart-items").length > 0) {
            if ($("form.mini-cart").hasClass("is-empty")) {
                $("form.mini-cart").removeClass("is-empty");

              if($('form.mini-cart .mini-cart__messages').length == 0){
                
                  
                    var newItemHtml = `
                      <div class="mini-cart__messages cart-message-jtpl">
                        <div class="cart-msg-inner-jtpl rte">
                          <p><a href="https://www.stilacosmetics.com/account/login" target="_blank" title="Sign-in"><strong>Sign-in</strong></a> now to earn <strong>Reward Points</strong> with this order!<br/> </p>
                        </div>
                      </div>
                    `;
                    // Append the new item to the cart drawer
                    $('.mini-cart__inner .mini-cart__header').after(newItemHtml);
                    console.log('newItemHtml: ' + newItemHtml);
                  
                
              }

              if($('form.mini-cart .custom-progress-bar').length > 0){
                var progress_bar = `
                    
                      <div class="mini-cart__shippingbar cart-shipping__wrapper custom-progress-bar" id="mini-cart__shippingbar"><div style="text-align: center; padding: 10px; margin: 10px 0; background-color: #f9f9f9; border: 1px solid #ddd;">
                            
                            
                            
                            
                            
                              
                              
                              
                              
                              
                              
                              
                              <p id="progress-message">Add $1 for FREE Shipping (Save $5.95)!</p>
                            
                            
                            <div id="progress-bar" >
                              <div style="width: 0%;"></div>
                            </div>
                            
                          </div>
                        
                      </div>
                    `;

                    $('.mini-cart__inner .mini-cart__header .cart-message-jtpl').after(progress_bar);
                    console.log('progress_bar: ' + progress_bar);
              }
                $(".mini-cart__empty").hide();
                $(".mini-cart__footer").show();
            }
            
            $("div.loader-cart-drwer-jtpl").removeClass("loading").hide();
            $('form.mini-cart .mini-cart__messages').show();
              
            // if($("form.mini-cart .mini-cart__navigation li").length == 0 ){
            //   $('form.mini-cart .mini-cart__messages').hide();
            // }
            
            var divCount = $(".flickity-slider .total-modalninfo").length;
            if (divCount <= 2) {
                $(".free-sample-products").addClass("arrow-disabled");
            } else {
                $(".free-sample-products").removeClass("arrow-disabled");
            }
        }

            if($("form.mini-cart .mini-cart__navigation li").length == 0 ){
              $("div.loader-cart-drwer-jtpl").removeClass("loading").hide();
                $('form.mini-cart .mini-cart__messages').hide();
              // alert($("form.mini-cart .mini-cart__navigation ul").length);
            }
            // if($('.mini-cart__empty').is(':visible')){
            //   $('.mini-cart__messages.cart-message-jtpl').hide();
            //   $(".mini-cart__main").hide();
            //   $(".free-sample-main-section").hide();
            // }else{
            //   $(".mini-cart__main").show();
            //    $(".free-sample-main-section").show();
            // }
            // if ($('.mini-cart__empty').css('display') === 'block') {
            //   $('.mini-cart__messages.cart-message-jtpl').hide();
            // }
            //  $("div.loader-cart-drwer-jtpl").removeClass("loading");
            // $("div.loader-cart-drwer-jtpl").hide();
            // var divCount = $(".flickity-slider .total-modalninfo").length;
            //   if (divCount < 2) {
            //     $(".free-sample-products").addClass("arrow-disabled");
            //   }else {
            //     $(".free-sample-products").removeClass("arrow-disabled");
            //   }
            //   var cart_count=$(carthtml).find('.cart-item-count').attr('data-count');
            // if($('.header__icon--cart .cart-count-bubble').length > 0){
            //   $('.header__icon--cart .cart-count-bubble').text(cart_count);
            // }else{
            //   $('.header__icon--cart').append(`<span class='cart-count-bubble'>${cart_count}</span>`); 
            // }
            
          }
        });
      }
      validateMaxfreeSample();
     slideFreeGift();
       cartBubble();
    }, 500);
  enableSlider();
  return false;
}

function cartBubble(){
      $.ajax({
  url: '/cart.json',
  type: "GET",
  dataType: "json",
  success: function (cart) {
   console.log(cart);
          if(cart.item_count >= 1){
            if($("#cart-icon-bubble.header__icon.header__icon--cart").find(".cart-count-bubble").length == 0){
              $("#cart-icon-bubble.header__icon.header__icon--cart").append('<span class="cart-count-bubble"><span aria-hidden="true">7</span><span class="visually-hidden">7 items</span>');
            }
          // Refresh only the cart section without reloading the page
             //$(".cart-count-bubble").addClass("cart-count-bubble--dot");
           $("#cart-icon-bubble .cart-count-bubble").find("span[aria-hidden='true']").html(cart.item_count);
            $("#cart-icon-bubble .cart-count-bubble").find("span.visibilty-hidden").html(cart.item_count+" items");
          }else{
            $("#cart-icon-bubble.header__icon.header__icon--cart").find(".cart-count-bubble").remove();
          }
  }
  });
  }
   function validateMaxfreeSample(){
    var maxValueFree = $(".free-sample-gift-container").attr("max-free-sample")
     // setTimeout(function(){
       jQuery.getJSON('/cart.js', function(cart) {
          var items = cart.items;
          var atc_flag = 0
          for( var i=0; i < items.length; i++ ){
             var item_handle = items[i].id;
             var properties = items[i].properties;
             if (items[i].properties != undefined && items[i].properties != '' && items[i].properties != null) {
             if( items[i].properties._free_sample_product == "free_sample_product" ){
               var atc_flag = parseInt(atc_flag+1)
               $('.add-free-sample-btn').css('display', 'block');
               $(".prdtClssAdd--"+item_handle).hide();
               $(".prdtClssRmv--"+item_handle).show();
             }
           }
        }   
         if( maxValueFree != atc_flag){
             $('.add-free-sample-btn').css('display', 'block');
           }
       if( maxValueFree <= atc_flag){
         $(".free-sample-atc-jtpl").prop("disabled", true)
       }
        });
          if($(".product-content .product-title").length > 0){
            $(".product-content .product-title").each(function(){ 
              var $this =$(this); var text =  $(this).text();
              
              if(text.indexOf("Stay All Day®") > -1){ 
              var new_text = text.replace("Stay All Day®","<strong>Stay All Day®</strong>"); 
              $this.html(new_text); 
              }
               if(text.indexOf("Correct & Perfect") > -1){ 
               var new_text = text.replace("Correct & Perfect","<strong>Correct & Perfect</strong>"); 
                $this.html(new_text); 
             }
              if(text.indexOf("Sculpt & Glow") > -1){ 
                 var new_text = text.replace("Sculpt & Glow","<strong>Sculpt & Glow</strong>"); 
                  $this.html(new_text); 
               }
              if(text.indexOf("One Step Correct") > -1){ 
              var new_text = text.replace("One Step Correct","<strong>One Step Correct</strong>"); 
              $this.html(new_text); 
             }
            }); 
          }
     
     slideFreeGift();
     }

   

 validateMaxfreeSample();
 $(document).ready(function(){
   
   // $(document).on('click','.spend-get-gift .spend-gift-tite',function(e){ 
   //    e.preventDefault();
   //    $('.spend_get_inner').toggle();
   //    $('.spend-gift-tite').toggleClass('close');
   // });
   
    $(document).on('click','.free-sample-main-section .main-headingcontent-jtpl',function(e){ 
      e.preventDefault();
      $('.free-sample-products').toggle();
      $('.main-headingcontent-jtpl').toggleClass('close');
   });
      // loadPowerReviews();
      $(document).on('click touchstart','.free-sample-atc-jtpl',function(){ 
          // e.preventDefault();
        $(".free-sample-atc-jtpl").prop("disabled",true);
        var product_id = $(this).attr("product-atc-id");
        $(this).hide();
        
        var properties = {};
        var GT_Data_Id = [];
        GT_Data_Id.push(product_id);
        properties["_free_sample_product"] = "free_sample_product";
        $.ajax({
          url: '/cart/add.js',
          async: false,
          type: 'POST',
          dataType: 'JSON',
          data: {id:GT_Data_Id , quantity:1, properties : properties},
          success: function(data){
            // console.log(data);
            $(this).siblings(".free-sample-remove-jtpl").show()
            updateCart();
            },
            error: function(error){
              console.log(error);
            }
          });
       });
   
         $(document).on('click touchstart','.free-sample-remove-jtpl',function(){ 
           // e.preventDefault();
            var product_id = $(this).attr("product-rmv-id")
            $(this).hide();
            
            jQuery.ajax({
              type: 'POST',
              url: '/cart/change.js',
              async: false,
              data:{
                id: product_id,
                quantity: 0
              },
              dataType: 'json',
              success: function(){
                // window.location.assign('/cart');
                // location.reload();
                $(this).siblings(".free-sample-atc-jtpl").show()
                updateCart();
              },
              error: function(error){
                console.log(error);   
              },
          });
       });

    
   
       $(document).on('click','button.modal-opener-free-sample',function(e){ 
         e.preventDefault();
         $(".data-modal-show").html('');
         $("body").addClass("quick-large-open");
         var modalData = $(this).parents(".total-modalninfo").find(".data-to-upload-jtpl").html();
         // console.log('show');
         $(".data-modal-show").html(modalData);
         $(".data-modal-show").show();
     });
   
     $(document).on('click','.modal_close-jtpl',function(e){ 
        e.preventDefault();
        $(".data-modal-show").hide();
        $("body").removeClass("quick-large-open");
     });
   
      $(document).on('click','.checkout__cart',function(){ 
        $(".data-modal-show").hide();
        $("body").removeClass("quick-large-open");
     });
   

    $(document).on('click','.colors-selection-jtpl label.color__swatch',function(e){
      e.preventDefault();
      var selectedvaljtppl = $(this).attr("data-title");
      var selectedval = $(this).attr("title");
      $('.modal_body-jtpl variant-radios input').prop("checked", false);
       $('.modal_body-jtpl variant-radios input[data-value-handle="'+selectedvaljtppl+'"]').prop('checked',true);
        
        var selectedvarjtppl = $(".custom-selected-jtpl option[data-var-val="+selectedvaljtppl+"]").attr("data-var-jtpl");
        var selectedimg = $(".custom-selected-jtpl option[data-var-val="+selectedvaljtppl+"]").attr("data-mg");
        $(".buy-atc-large").attr("product-atc-id-large",selectedvarjtppl);
        $('.main-media-modal img').attr('src',selectedimg);
      $(this).parent("fieldset").find("legend").find("#color-mini-cart").html("-&nbsp;"+selectedval);
      
    });

     $(document).on('click','.buy-atc-large',function(e){ 
       e.preventDefault();
       var product_id = $(this).attr("product-atc-id-large");
       var GT_Data_Id = [];
       GT_Data_Id.push(product_id);
       $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'JSON',
          data: {id:GT_Data_Id , quantity:1 },
          success: function(){
            $('.modal_close-jtpl').trigger("click");
            $('#cart-icon-bubble').trigger("click");
              var interval = setInterval(function(){
              if($('#freesample-mini-cart.cart-flickty-slider-enabled').hasClass('flickity-enabled')){
                clearInterval(interval);
              }else{
                $("#freesample-mini-cart.cart-flickty-slider-enabled").flickity({
                  wrapAround: true,
                  pageDots: false,
                  initialIndex: 1,
                  accessibility: true,
                  autoPlay: false
                });
              }
            },500);
            // window.location.assign('/cart');
            // location.reload();
            updateCart();
          },
          error: function(){
            console.log("error")
          }
        });
     });
   
     $(document).on('click','.var-swatch-img-jtpl',function(e){ 
         e.preventDefault();
         $(".var-swatch-img-jtpl").removeClass("active-swatch");
         var product_id = $(this).attr("data-vvid");
         var var_img = $(this).attr("var-img-src");
         var var_title = $(this).attr("var-title-jtpl");
           $(this).parents(".modal_body-jtpl").find("span.clr-ttl-jtpl").html(var_title);
         $(this).parents(".modal_body-jtpl").find(".main-media-modal img").attr("src",var_img);
         $(this).addClass("active-swatch");
         $(this).parents(".modal_body-jtpl").find(".main-full-btn-jtpl a").attr("product-atc-id-large",product_id);
     });
  });